import { render } from "./DashboardEditPage.vue?vue&type=template&id=3e60f551&scoped=true"
import script from "./DashboardEditPage.vue?vue&type=script&lang=js"
export * from "./DashboardEditPage.vue?vue&type=script&lang=js"

import "./DashboardEditPage.vue?vue&type=style&index=0&id=3e60f551&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e60f551"]])

export default __exports__